import TableV1, { createColumn, ColumnType, sort, SortBy, Order, RowTypeConstant, HeaderCellTypeConstant } from './v1';
import { get as versionSelector } from '../../../utils/versionSelector';

const version = new Map([
  [1, TableV1]
]);

/**
 * @type {(version: number) => React.JSX.Element}
 */
export const get = versionSelector.bind(this, version);

export {
  createColumn,
  sort,
  ColumnType,
  SortBy,
  Order,
  RowTypeConstant,
  HeaderCellTypeConstant
};

export default TableV1;
